import React from 'react';
import useClassNames from 'helpers/hooks/useClassNames';

interface DividerProps {
  className?: string;
}

const Divider: React.FC<DividerProps> = ({ className }) => {
  const dividerClassName = useClassNames(['w-full border-t border-stroke-primary', className]);

  return <hr className={dividerClassName} />;
};

export default Divider;
